module.exports = __webpack_public_path__ + "media/images/countryrect/gy-1dace5fa4b8d43120ea8c19b70e7c11b.svg";